import { z } from "zod";
import { formatNationalPhone } from "./profileInputs";

export const FRACTIONAL_INQUIRY_SERVICES = {
  general: "A general conversation",
  "talent-acquisition": "Talent Acquisition & Retained Search",
  "employee-experience": "Employee Experience & Organizational Effectiveness",
  compensation: "Compensation Strategy & Job Architecture",
} as const;

export const fractionalInquirySchema = z.object({
  submissionId: z.string().uuid(),
  name: z.string().trim().min(2).max(120).refine(value => !/[\r\n\u0000]/.test(value), "Use one line for your name."),
  email: z.string().trim().toLowerCase().email().max(254),
  phone: z.string().trim().max(24).default("").refine(value => !value || /^(?:\+?1[ .-]?)?(?:\(\d{3}\)|\d{3})[ .-]?\d{3}[ .-]?\d{4}$/.test(value), "Enter a complete 10-digit phone number.").transform(value => value ? formatNationalPhone("+1", value) : ""),
  organization: z.string().trim().max(160).refine(value => !/[\r\n\u0000]/.test(value), "Use one line for your organization."),
  service: z.enum(["general", "talent-acquisition", "employee-experience", "compensation"]),
  message: z.string().trim().min(10).max(3000).refine(value => !value.includes("\u0000")),
  privacyAcknowledged: z.literal(true),
  website: z.string().max(200),
}).strict();
